import { render, staticRenderFns } from "./menuReviewplatformActions.vue?vue&type=template&id=69724e81"
import script from "./menuReviewplatformActions.vue?vue&type=script&lang=js"
export * from "./menuReviewplatformActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports